function toStamp(date) {
  return date.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
}

function bounds(event) {
  const start = new Date(event.start_iso);
  const end = new Date(start.getTime() + 3 * 60 * 60 * 1000);
  return { start, end };
}

export function googleCalendarUrl(event) {
  const { start, end } = bounds(event);
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: event.name,
    dates: `${toStamp(start)}/${toStamp(end)}`,
    details: `${event.description}\n\nBook: ${event.booking_link}`,
    location: event.location,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function downloadIcs(event) {
  const { start, end } = bounds(event);
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//RoadRnr//EN",
    "BEGIN:VEVENT",
    `UID:${event.id}@roadrnr`,
    `DTSTAMP:${toStamp(new Date())}`,
    `DTSTART:${toStamp(start)}`,
    `DTEND:${toStamp(end)}`,
    `SUMMARY:${event.name}`,
    `DESCRIPTION:${event.description.replace(/\n/g, " ")} Book: ${event.booking_link}`,
    `LOCATION:${event.location}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");

  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${event.id}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
